import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import UserDetails from "./userDetails";
import AdCarousel from "./adCarousel";
import ReminderCards from "./reminderCards/ReminderCards";
import FeaturedRecipies from "./featuredRecipes";
import { getHomeData, getWeightHistory, getAds, getMotivationalVideos } from "../../store/actions";
import { connect } from "react-redux";
import WeightHistory from "./weightHistory";
import FeaturedExercises from "./featuredExercises";
import MyFitness from "./myFitness";
import MyNutrition from "./myNutrition/MyNutrition";
import FoodNutrition from "./foodNutrition";
import { slice, get } from "lodash";
import "./home.scss";

function Home({
	recipesFavourited,
	featuredRecipies,
	motivationalVideos,
	recentlyReviewed,
	weightHistory,
	history,
	featuredExercises,
	userDetails,
	myFitness,
	recipesSubmitted,
	ads,
	getHomeData,
	getAds,
	getWeightHistory,
	getMotivationalVideos,
	latestBadge
}) {
	const [adList, setAddList] = useState(null);

	useEffect(() => {
		getHomeData();
		getWeightHistory();
		getAds(ev => {
			ev && setAddList([]);
		});
		getMotivationalVideos();
	}, [getHomeData, getWeightHistory, getAds, getMotivationalVideos]);

	useEffect(() => {		
		setAddList(ads && ads.length ? ads.filter((item) => {
			return item.is_active === true;
		}) : []);
	}, [ads]);

	const motivationalVideosList =
		motivationalVideos &&
		motivationalVideos.filter((item) => {
			return item.is_active === true;
		});

	return (
		<Container className="main-home-container">
			<Row>
				<Col>
					<UserDetails userDetails={userDetails} />
				</Col>
			</Row>
			<Row>
				<Col xs={5}>
					<AdCarousel ads={adList} height="400px" componentIdentifier="ad" />
				</Col>
				<Col xs={3}>
					<ReminderCards userDetails={userDetails} latestBadge={latestBadge} history={history} />
				</Col>
				<Col xs={4}>
					<FeaturedRecipies featuredRecipies={featuredRecipies} history={history} />
				</Col>
			</Row>

			<Row className="row-3">
				<Col xs={4}>
					<WeightHistory weightHistory={weightHistory} />
				</Col>
				<Col xs={4}>
					<AdCarousel ads={motivationalVideosList} height="380px" />
				</Col>
				<Col xs={4}>
					<FeaturedExercises featuredExercises={featuredExercises} history={history} />
				</Col>
			</Row>

			<Row className="row-4">
				<Col xs={4}>
					<MyFitness myFitness={myFitness} />
				</Col>
				<Col xs={4}>
					<MyNutrition
						recipesSubmitted={recipesSubmitted}
						recipesFavourited={recipesFavourited}
						recentlyReviewed={recentlyReviewed}
						history={history}
					/>
				</Col>
				<Col xs={4}>
					<FoodNutrition history={history} />
				</Col>
			</Row>
		</Container>
	);
}

const mapStateToProps = (state) => {
	const { Home, Auth } = state;

	return {
		featuredRecipies: get(Home, "featured_recipes", null),
		featuredExercises: get(Home, "featured_exercises", null),
		userDetails: Auth.userDetails,
		myFitness: get(Home, "my_fitness", null),
		recipesSubmitted: slice(get(Home, "recipes_submitted", []), 0, 4),
		recipesFavourited: slice(get(Home, "recipes_favorited", []), 0, 4),
		recentlyReviewed: slice(get(Home, "recently_reviewed", []), 0, 4),
		ads: get(Home, "ads", null),
		motivationalVideos: get(Home, "motivational_videos", []),
		weightHistory: get(Home, "weight_history", []),
		latestBadge: get(Home, "latest_badge", null)
	};
};

const mapDispatchToProps = {
	getHomeData,
	getWeightHistory,
	getAds,
	getMotivationalVideos
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Home);
